<template>
  <el-cascader
    style="width: 100%"
    v-model="val"
    :options="cvtOptions"
    :props="{ checkStrictly: checkStrictly, multiple: multiple }"
    filterable
    v-bind="$attrs"
  >
    <template #default="{ node, data }">
      <render-vnode :vnode="getIcon(data)"></render-vnode>
      <span class="resource-item-label">{{ data.label }}</span>
    </template>
  </el-cascader>
</template>
<script>
import { getMenuIcons } from '../plugins/utils'
export default {
  name: 'resource-cascader',
  props: {
    options: Array,
    value: [String, Array],
    topLevel: {
      type: Boolean,
      default: true
    },
    nid: String, //父级id不能与自身id相同
    checkStrictly: {
      type: Boolean,
      default: true
    },
    multiple: Boolean,
    calcItemDisabled: Function
  },
  computed: {
    cvtOptions() {
      var options = this.deepCopy(this.options, false)
      if (this.topLevel) {
        return [
          {
            label: '最上级',
            value: '0',
            id: '0',
            children: options
          }
        ]
      }
      return options
    },
    val: {
      get() {
        console.log('val', this.value)
        if (Array.isArray(this.value)) {
          return this.value
        }
        var ids = []
        this.deepIds(this.cvtOptions, this.value, ids)
        return ids
      },
      set(newVal) {
        if (this.multiple) {
          this.$emit('input', newVal)
        } else {
          this.$emit(
            'input',
            newVal.length > 0 ? newVal[newVal.length - 1] : ''
          )
        }

        this.$emit('selected')
      }
    }
  },
  methods: {
    deepCopy(rows, parentDisabled) {
      var ret = []
      for (var row of rows) {
        var label = row.name
        if (row.res_type == 'rel' && row.use_rel_name) {
          label = row.rel_name
        }
        var item = {
          label,
          value: row.id,
          res_type: row.res_type,
          rel_res_type: row.rel_res_type,
          meun_path: row.meun_path,
          rel_meun_path: row.rel_meun_path
        }
        if (row.id == this.nid || parentDisabled || row.res_type == 'rel') {
          item.disabled = true
        }
        if (this.calcItemDisabled) {
          item.disabled = this.calcItemDisabled(item.disabled || false, row)
        }
        if (Array.isArray(row.children)) {
          var children = this.deepCopy(row.children, item.disabled)
          if (children && children.length > 0) {
            item.children = children
          }
        }
        ret.push(item)
      }
      return ret
    },
    deepIds(rows, value, values) {
      for (var row of rows) {
        if (row.value == value) {
          values.push(value)
          return true
        } else if (Array.isArray(row.children)) {
          if (this.deepIds(row.children, value, values)) {
            values.unshift(row.value)
            return true
          }
        }
      }
      return false
    },
    getIcon(data) {
      var icons = getMenuIcons(data)
      if (icons.length > 0) {
        return (
          <span style='margin-right: 2px'>
            {icons.map((icon) => (
              <i class={icon} style='margin-right: 2px'></i>
            ))}
          </span>
        )
      }
      return null
    }
  }
}
</script>
